/* eslint-disable import/prefer-default-export */
import { useQuery } from '@apollo/client'
import {
  ProductByHandleQuery,
  ProductByHandleQueryVariables,
} from '../../types/storefront'
import productByHandle from '../api/graphql/productByHandlerQuery.gql'
import productRecommendQuery from '../api/graphql/productRecommendQuery.gql'

export function useGetProductByHandler(handle: string) {
  const query = useQuery<ProductByHandleQuery, ProductByHandleQueryVariables>(
    productByHandle,
    {
      variables: {
        handle,
      },
      skip: !handle,
    }
  )
  return {
    query,
  }
}

// productId 商品ID
export function useGetProductRecommendById(productId: string) {
  const query = useQuery(productRecommendQuery, {
    variables: {
      productId,
    },
  })
  return {
    query,
  }
}
